import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { PageWrapper } from '@/shared/ui/page-wrapper'
import { PathCard } from '@/shared/ui/path-card'

export const Route = createFileRoute('/_auth/canteen/')({
  staticData: {
    meta: {
      title: 'Столовая',
      description: '',
    },
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { t } = useTranslation()
  return (
    <PageWrapper title={t('Столовая')}>
      <PathCard path="/canteen/menu-settings" title={t('Настройка меню')} />
      <PathCard
        path="/canteen/manual-attendance-and-food-receipt/list"
        title={t('Ручной учет посещения и получения питания')}
      />
      <PathCard path="/canteen/meal-restrictions" title={t('Ограничения в питании')} />
    </PageWrapper>
  )
}
